import React from 'react'

import Grid from '@material-ui/core/Grid'
import { isOfTypeImage } from 'util/quiz-trivia'
import LegacyImage from 'components/LegacyImage'
import questionCorrect from 'images/icon-check.svg'
import questionIncorrect from 'images/icon-x.svg'
import QuizNextButton from 'images/inline/arrow-right.svg'

const QuestionSlide = ({
  question,
  currentPosition,
  totalQuestions,
  currentAnswerIsTrue,
  handleAnswerClick,
  selectedAnswerId,
  backgroundImage,
  backgroundColor,
  answeredText,
  answerResultSlide,
  isEditorial,
  nextButtonHandler,
}) => {
  // TODO - This should be the preferred way to determine type, but the backend is weird like that
  // Ex: question.type === 'TEXT', answer.type === 'IMAGE' is possible....

  let style = {}

  if (backgroundColor) {
    style.backgroundColor = backgroundColor
  }

  if (backgroundImage && backgroundImage.id) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${backgroundImage.id})`
  }

  return (
    <div
      className={`quiz__item bg-img quiz__item-${currentPosition}`}
      key={question.id}
      // style={style}
    >
      <div className="container">
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} sm={11} md={9}>
            <div
              className={`quiz__inner-box quiz__question${
                backgroundImage ? ' bg-image' : ' no-bg-image'
              } ${
                question.image ? ' has-progress-image' : ' no-progress-image'
              } ${isEditorial ? `editorial-quiz-item` : ''}`}
            >
              <div className="quiz__progress">
                <span className="quiz__progress-text">Trivia</span>

                <span className="quiz__progress-number">
                  {currentPosition} of {totalQuestions}
                </span>
                <ul className="quiz__progress-dots">
                  {Array.from({ length: totalQuestions }).map((_, i) => {
                    return (
                      <li
                        key={i}
                        className={`${i < currentPosition ? 'active' : ''}`}
                      ></li>
                    )
                  })}
                </ul>
              </div>
              {question.image && (
                <div className="quiz__progress-img bg-img">
                  <img
                    src={`${process.env.SITE_ASSET_URL}/${question.image.id}`}
                  />
                </div>
              )}
              <h2 dangerouslySetInnerHTML={{ __html: question.text }}></h2>
              {!answerResultSlide ? (
                <>
                  <ul
                    className={`quiz__question-list${
                      isOfTypeImage(question) ? ' image-choices' : ''
                    }`}
                  >
                    {question.answers.map((answer, i) => {
                      return (
                        <li
                          tabIndex={0}
                          key={i}
                          className={`
                              ${
                                selectedAnswerId === answer.id ? 'selected' : ''
                              }
                            `}
                        >
                          {answer.type === 'TEXT' && (
                            <label className="custom-btn-label">
                              <input
                                type="radio"
                                name={question.id}
                                onClick={() =>
                                  handleAnswerClick({
                                    question: question,
                                    answer: answer,
                                    answeredText: question.textAnswered,
                                    currentPosition: currentPosition,
                                    totalQuestions: totalQuestions,
                                  })
                                }
                              />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: answer.text,
                                }}
                              ></span>
                            </label>
                          )}
                          {answer.type === 'IMAGE' && (
                            <div
                              className="image-choice"
                              onClick={() =>
                                handleAnswerClick({
                                  question: question,
                                  answer: answer,
                                  answeredText: question.textAnswered,
                                  currentPosition: currentPosition,
                                  totalQuestions: totalQuestions,
                                })
                              }
                            >
                              <LegacyImage image={answer.image} />
                            </div>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </>
              ) : (
                <>
                  <div
                    className={`quiz__single-answer ${
                      currentAnswerIsTrue ? 'correct' : 'incorrect'
                    }`}
                  >
                    <div className="quiz__correct-ans">
                      <img
                        src={
                          currentAnswerIsTrue
                            ? questionCorrect
                            : questionIncorrect
                        }
                        alt=""
                        className="quiz__correct-icn"
                      />
                      <strong className={`result-text`}>
                        {currentAnswerIsTrue ? 'Correct' : 'Incorrect'}
                      </strong>
                    </div>
                    <div className="quiz__single-desc">
                      {isEditorial === true && (
                        <strong className={`result-text`}>
                          {currentAnswerIsTrue ? 'Correct' : 'Incorrect'}
                        </strong>
                      )}
                      <p dangerouslySetInnerHTML={{ __html: answeredText }}></p>
                    </div>
                  </div>
                  {isEditorial === true && (
                    <div className={`editorial-quiz-button-container`}>
                      <button
                        className={`quiz-button`}
                        id="next-btn"
                        onClick={nextButtonHandler}
                        aria-label="Next"
                      >
                        <QuizNextButton />
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default QuestionSlide
